import { createContext, useContext } from 'react';
import defaultBackground from './assets/background.png';

type TContext = [string, (backgroundImg: string) => void];

export const BackgroundContext = createContext<TContext>([defaultBackground, () => {}]);

export const useBackgroundContext = () => useContext(BackgroundContext);
